export default function geteRelativeUrl() {
    if (process.env.NODE_ENV == "development") return `http://localhost:3200/api/`
    return "/api/"
}